import React, { FC, ReactNode } from "react";
import styled from "styled-components";

type Props = React.HTMLProps<HTMLSelectElement> & { children: ReactNode };

export const FormSelect: FC<Props> = ({ children, ...rest }) => {
  return (
    <OuterContainer>
      <select className="form-control" {...rest}>
        {children}
      </select>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  select {
    background: url("data:image/svg+xml,%3Csvg viewBox='0 0 26 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 3.9234L3.86003 0.000414456L16.7268 13.077L12.8668 17L0 3.9234Z' fill='%235A7DFD'/%3E%3Cpath d='M26 3.92298L22.14 0L9.27321 13.0766L13.1332 16.9996L26 3.92298Z' fill='%235A7DFD'/%3E%3C/svg%3E")
      no-repeat right;
    -webkit-appearance: none;
    background-origin: content-box;
    background-size: 10% 50%;
    color: var(--secondary);
    box-shadow: 0 0 3px 0 #00092b;
  }
`;
